import script from "./ProfilePremium.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilePremium.vue?vue&type=script&setup=true&lang=js"

import "./ProfilePremium.vue?vue&type=style&index=0&id=71db17f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71db17f2"]])

export default __exports__